angular.module("ainapp")
    .controller("TabDesignController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Tab Design";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.load = false;

                $scope.ViewVal = 0;
                $scope.ViewValType = 'Material Request';

                $scope.CostSetting = {
                    VoucherName: "Material Request",
                }

                $scope.Vdesign = {};
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.TabDesignsbyType("Material Request").then(function (response) {

                    if (response.data != null) {

                        $scope.Vdesign = {
                            Id: response.data.Id,
                            DateTabVal: response.data.DateTabVal.toString(),
                            CustomerTabVal: response.data.CustomerTabVal.toString(),
                            CustomerMobTabVal: response.data.CustomerMobTabVal.toString(),
                            CustomerAddressTabVal: response.data.CustomerAddressTabVal.toString(),
                            ExcelTabVal: response.data.ExcelTabVal.toString(),
                            CRDRAccountTabVal: response.data.CRDRAccountTabVal.toString(),
                            CurrencyTabVal: response.data.CurrencyTabVal.toString(),
                            RemarksTabVal: response.data.RemarksTabVal.toString(),
                            IntroLetterTabVal: response.data.IntroLetterTabVal.toString(),
                            EndLetterTabVal: response.data.EndLetterTabVal.toString(),
                            ValidityTabVal: response.data.ValidityTabVal.toString(),
                            ConcernPersonTabVal: response.data.ConcernPersonTabVal.toString(),
                            PlaceOfSupplyTabVal: response.data.PlaceOfSupplyTabVal.toString(),
                            ShippingAddressTabVal: response.data.ShippingAddressTabVal.toString(),
                            SupplierBillNoTabVal: response.data.SupplierBillNoTabVal.toString(),
                            SupplierQTNNoTabVal: response.data.SupplierQTNNoTabVal.toString(),
                            WeightTabVal: response.data.WeightTabVal.toString(),
                            NoOfPackagesTabVal: response.data.NoOfPackagesTabVal.toString(),
                            GrossWeightTabVal: response.data.GrossWeightTabVal.toString(),
                            NetWeightTabVal: response.data.NetWeightTabVal.toString(),
                            EnquiryNoTabVal: response.data.EnquiryNoTabVal.toString(),
                            OrderNoTabVal: response.data.OrderNoTabVal.toString(),
                            WarrentyPeriodTabVal: response.data.WarrentyPeriodTabVal.toString(),
                            DeliveryPeriodTabVal: response.data.DeliveryPeriodTabVal.toString(),
                            DeliveryBasisTabVal: response.data.DeliveryBasisTabVal.toString(),
                            PaymentTermsTabVal: response.data.PaymentTermsTabVal.toString(),
                            DeliveryDateTabVal: response.data.DeliveryDateTabVal.toString(),
                            ReturnDateTabVal: response.data.ReturnDateTabVal.toString(),
                            ReturnTimeTabVal: response.data.ReturnTimeTabVal.toString(),
                            SupplierBillDateTabVal: response.data.SupplierBillDateTabVal.toString(),
                            SalesEmployeeTabVal: response.data.SalesEmployeeTabVal.toString(),
                            CustomerPOTabVal: response.data.CustomerPOTabVal.toString(),
                            SupplierPOTabVal: response.data.SupplierPOTabVal.toString(),
                            Field1TabVal: response.data.Field1TabVal.toString(),
                            Field2TabVal: response.data.Field2TabVal.toString(),
                            Field3TabVal: response.data.Field3TabVal.toString(),
                            Field4TabVal: response.data.Field4TabVal.toString(),
                            Field5TabVal: response.data.Field5TabVal.toString(),
                            Field6TabVal: response.data.Field6TabVal.toString(),
                            Field7TabVal: response.data.Field7TabVal.toString(),
                            Field8TabVal: response.data.Field8TabVal.toString(),
                            Field9TabVal: response.data.Field9TabVal.toString(),
                            Field10TabVal: response.data.Field10TabVal.toString(),
                            Field11TabVal: response.data.Field11TabVal.toString(),
                            Field12TabVal: response.data.Field12TabVal.toString(),
                            Field13TabVal: response.data.Field13TabVal.toString(),
                            Field14TabVal: response.data.Field14TabVal.toString(),
                            Field15TabVal: response.data.Field15TabVal.toString(),
                            Field16TabVal: response.data.Field16TabVal.toString(),
                            Field17TabVal: response.data.Field17TabVal.toString(),
                            Field18TabVal: response.data.Field18TabVal.toString(),
                            Field19TabVal: response.data.Field19TabVal.toString(),
                            Field20TabVal: response.data.Field20TabVal.toString(),
                            Master1TabVal: response.data.Master1TabVal.toString(),
                            Master2TabVal: response.data.Master2TabVal.toString(),
                            Master3TabVal: response.data.Master3TabVal.toString(),
                            Master4TabVal: response.data.Master4TabVal.toString(),
                            Master5TabVal: response.data.Master5TabVal.toString(),
                            DProductCodeTabVal: response.data.DProductCodeTabVal.toString(),
                            DProductNameTabVal: response.data.DProductNameTabVal.toString(),
                            DDescriptionTabVal: response.data.DDescriptionTabVal.toString(),
                            DBrandTabVal: response.data.DBrandTabVal.toString(),
                            DCountryTabVal: response.data.DCountryTabVal.toString(),
                            DYRRefTabVal: response.data.DYRRefTabVal.toString(),
                            DManufTabVal: response.data.DManufTabVal.toString(),
                            DStockTabVal: response.data.DStockTabVal.toString(),
                            DUnitTabVal: response.data.DUnitTabVal.toString(),
                            DVatTabVal: response.data.DVatTabVal.toString(),
                            DVatTypeTabVal: response.data.DVatTypeTabVal.toString(),
                            DQuantityTabVal: response.data.DQuantityTabVal.toString(),
                            DUnitPriceTabVal: response.data.DUnitPriceTabVal.toString(),
                            DCostTabVal: response.data.DCostTabVal.toString(),
                            DTCostTabVal: response.data.DTCostTabVal.toString(),
                            DQCostTabVal: response.data.DQCostTabVal.toString(),
                            DBonusTabVal: response.data.DBonusTabVal.toString(),
                            DGrossTabVal: response.data.DGrossTabVal.toString(),
                            DDiscountValueTabVal: response.data.DDiscountValueTabVal.toString(),
                            DDiscountTypeTabVal: response.data.DDiscountTypeTabVal.toString(),
                            DDiscountTabVal: response.data.DDiscountTabVal.toString(),
                            DOtherChargesTabVal: response.data.DOtherChargesTabVal.toString(),
                            DTaxableTabVal: response.data.DTaxableTabVal.toString(),
                            DTotalVATTabVal: response.data.DTotalVATTabVal.toString(),
                            DRoundOffVatTabVal: response.data.DRoundOffVatTabVal.toString(),
                            DExtraChargesTabVal: response.data.DExtraChargesTabVal.toString(),
                            DTotalTabVal: response.data.DTotalTabVal.toString(),
                            DWarehouseTabVal: response.data.DWarehouseTabVal.toString(),
                            DField1TabVal: response.data.DField1TabVal.toString(),
                            DField2TabVal: response.data.DField2TabVal.toString(),
                            DField3TabVal: response.data.DField3TabVal.toString(),
                            DField4TabVal: response.data.DField4TabVal.toString(),
                            DField5TabVal: response.data.DField5TabVal.toString(),
                            DField6TabVal: response.data.DField6TabVal.toString(),
                            DField7TabVal: response.data.DField7TabVal.toString(),
                            DField8TabVal: response.data.DField8TabVal.toString(),
                            DField9TabVal: response.data.DField9TabVal.toString(),
                            DField10TabVal: response.data.DField10TabVal.toString(),
                            DField11TabVal: response.data.DField11TabVal.toString(),
                            DField12TabVal: response.data.DField12TabVal.toString(),
                            DField13TabVal: response.data.DField13TabVal.toString(),
                            DField14TabVal: response.data.DField14TabVal.toString(),
                            DField15TabVal: response.data.DField15TabVal.toString(),
                            DField16TabVal: response.data.DField16TabVal.toString(),
                            DField17TabVal: response.data.DField17TabVal.toString(),
                            DField18TabVal: response.data.DField18TabVal.toString(),
                            DField19TabVal: response.data.DField19TabVal.toString(),
                            DField20TabVal: response.data.DField20TabVal.toString(),
                            DMaster6TabVal: response.data.DMaster6TabVal.toString(),
                            DMaster7TabVal: response.data.DMaster7TabVal.toString(),
                            DMaster8TabVal: response.data.DMaster8TabVal.toString(),
                            DFreightCharges: response.data.DFreightCharges.toString(),
                            DClearingCharges: response.data.DClearingCharges.toString(),
                            DDutyCharges: response.data.DDutyCharges.toString(),
                            DDeliveryCharges: response.data.DDeliveryCharges.toString(),
                            DPackingCharges: response.data.DPackingCharges.toString(),
                        }


                    } else {
                        $scope.Vdesign = {
                            DateTabVal: "-1",
                            CustomerTabVal: "-1",
                            CustomerMobTabVal: "-1",
                            CustomerAddressTabVal: "-1",
                            ExcelTabVal: "-1",
                            CRDRAccountTabVal: "-1",
                            CurrencyTabVal: "-1",
                            RemarksTabVal: "-1",
                            IntroLetterTabVal: "-1",
                            EndLetterTabVal: "-1",
                            ValidityTabVal: "-1",
                            ConcernPersonTabVal: "-1",
                            PlaceOfSupplyTabVal: "-1",
                            ShippingAddressTabVal: "-1",
                            SupplierBillNoTabVal: "-1",
                            SupplierQTNNoTabVal: "-1",
                            WeightTabVal: "-1",
                            NoOfPackagesTabVal: "-1",
                            GrossWeightTabVal: "-1",
                            NetWeightTabVal: "-1",
                            EnquiryNoTabVal: "-1",
                            OrderNoTabVal: "-1",
                            WarrentyPeriodTabVal: "-1",
                            DeliveryPeriodTabVal: "-1",
                            DeliveryBasisTabVal: "-1",
                            PaymentTermsTabVal: "-1",
                            DeliveryDateTabVal: "-1",
                            ReturnDateTabVal: "-1",
                            ReturnTimeTabVal: "-1",
                            SupplierBillDateTabVal: "-1",
                            SalesEmployeeTabVal: "-1",
                            CustomerPOTabVal: "-1",
                            SupplierPOTabVal: "-1",
                            Field1TabVal: "-1",
                            Field2TabVal: "-1",
                            Field3TabVal: "-1",
                            Field4TabVal: "-1",
                            Field5TabVal: "-1",
                            Field6TabVal: "-1",
                            Field7TabVal: "-1",
                            Field8TabVal: "-1",
                            Field9TabVal: "-1",
                            Field10TabVal: "-1",
                            Field11TabVal: "-1",
                            Field12TabVal: "-1",
                            Field13TabVal: "-1",
                            Field14TabVal: "-1",
                            Field15TabVal: "-1",
                            Field16TabVal: "-1",
                            Field17TabVal: "-1",
                            Field18TabVal: "-1",
                            Field19TabVal: "-1",
                            Field20TabVal: "-1",
                            Master1TabVal: "-1",
                            Master2TabVal: "-1",
                            Master3TabVal: "-1",
                            Master4TabVal: "-1",
                            Master5TabVal: "-1",
                            DProductCodeTabVal: "-1",
                            DProductNameTabVal: "-1",
                            DDescriptionTabVal: "-1",
                            DBrandTabVal: "-1",
                            DCountryTabVal: "-1",
                            DYRRefTabVal: "-1",
                            DManufTabVal: "-1",
                            DStockTabVal: "-1",
                            DUnitTabVal: "-1",
                            DVatTabVal: "-1",
                            DVatTypeTabVal: "-1",
                            DQuantityTabVal: "-1",
                            DUnitPriceTabVal: "-1",
                            DCostTabVal: "-1",
                            DTCostTabVal: "-1",
                            DQCostTabVal: "-1",
                            DBonusTabVal: "-1",
                            DGrossTabVal: "-1",
                            DDiscountValueTabVal: "-1",
                            DDiscountTypeTabVal: "-1",
                            DDiscountTabVal: "-1",
                            DOtherChargesTabVal: "-1",
                            DTaxableTabVal: "-1",
                            DTotalVATTabVal: "-1",
                            DRoundOffVatTabVal: "-1",
                            DExtraChargesTabVal: "-1",
                            DTotalTabVal: "-1",
                            DWarehouseTabVal: "-1",
                            DField1TabVal: "-1",
                            DField2TabVal: "-1",
                            DField3TabVal: "-1",
                            DField4TabVal: "-1",
                            DField5TabVal: "-1",
                            DField6TabVal: "-1",
                            DField7TabVal: "-1",
                            DField8TabVal: "-1",
                            DField9TabVal: "-1",
                            DField10TabVal: "-1",
                            DField11TabVal: "-1",
                            DField12TabVal: "-1",
                            DField13TabVal: "-1",
                            DField14TabVal: "-1",
                            DField15TabVal: "-1",
                            DField16TabVal: "-1",
                            DField17TabVal: "-1",
                            DField18TabVal: "-1",
                            DField19TabVal: "-1",
                            DField20TabVal: "-1",
                            DMaster6TabVal: "-1",
                            DMaster7TabVal: "-1",
                            DMaster8TabVal: "-1",
                            DFreightCharges: "-1",
                            DClearingCharges: "-1",
                            DDutyCharges: "-1",
                            DDeliveryCharges: "-1",
                            DPackingCharges: "-1",
                        }
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }
            $scope.Init();


            $scope.switchTab = function (tab, type) {
                $scope.ViewVal = tab;
                $scope.ViewValType = type;
                $scope.Vdesign = {};
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.TabDesignsbyType(type).then(function (response) {

                    if (response.data != null) {

                        $scope.Vdesign = {
                            Id: response.data.Id,
                            DateTabVal: response.data.DateTabVal.toString(),
                            CustomerTabVal: response.data.CustomerTabVal.toString(),
                            CustomerMobTabVal: response.data.CustomerMobTabVal.toString(),
                            CustomerAddressTabVal: response.data.CustomerAddressTabVal.toString(),
                            ExcelTabVal: response.data.ExcelTabVal.toString(),
                            CRDRAccountTabVal: response.data.CRDRAccountTabVal.toString(),
                            CurrencyTabVal: response.data.CurrencyTabVal.toString(),
                            RemarksTabVal: response.data.RemarksTabVal.toString(),
                            IntroLetterTabVal: response.data.IntroLetterTabVal.toString(),
                            EndLetterTabVal: response.data.EndLetterTabVal.toString(),
                            ValidityTabVal: response.data.ValidityTabVal.toString(),
                            ConcernPersonTabVal: response.data.ConcernPersonTabVal.toString(),
                            PlaceOfSupplyTabVal: response.data.PlaceOfSupplyTabVal.toString(),
                            ShippingAddressTabVal: response.data.ShippingAddressTabVal.toString(),
                            SupplierBillNoTabVal: response.data.SupplierBillNoTabVal.toString(),
                            SupplierQTNNoTabVal: response.data.SupplierQTNNoTabVal.toString(),
                            WeightTabVal: response.data.WeightTabVal.toString(),
                            NoOfPackagesTabVal: response.data.NoOfPackagesTabVal.toString(),
                            GrossWeightTabVal: response.data.GrossWeightTabVal.toString(),
                            NetWeightTabVal: response.data.NetWeightTabVal.toString(),
                            EnquiryNoTabVal: response.data.EnquiryNoTabVal.toString(),
                            OrderNoTabVal: response.data.OrderNoTabVal.toString(),
                            WarrentyPeriodTabVal: response.data.WarrentyPeriodTabVal.toString(),
                            DeliveryPeriodTabVal: response.data.DeliveryPeriodTabVal.toString(),
                            DeliveryBasisTabVal: response.data.DeliveryBasisTabVal.toString(),
                            PaymentTermsTabVal: response.data.PaymentTermsTabVal.toString(),
                            DeliveryDateTabVal: response.data.DeliveryDateTabVal.toString(),
                            ReturnDateTabVal: response.data.ReturnDateTabVal.toString(),
                            ReturnTimeTabVal: response.data.ReturnTimeTabVal.toString(),
                            SupplierBillDateTabVal: response.data.SupplierBillDateTabVal.toString(),
                            SalesEmployeeTabVal: response.data.SalesEmployeeTabVal.toString(),
                            CustomerPOTabVal: response.data.CustomerPOTabVal.toString(),
                            SupplierPOTabVal: response.data.SupplierPOTabVal.toString(),
                            Field1TabVal: response.data.Field1TabVal.toString(),
                            Field2TabVal: response.data.Field2TabVal.toString(),
                            Field3TabVal: response.data.Field3TabVal.toString(),
                            Field4TabVal: response.data.Field4TabVal.toString(),
                            Field5TabVal: response.data.Field5TabVal.toString(),
                            Field6TabVal: response.data.Field6TabVal.toString(),
                            Field7TabVal: response.data.Field7TabVal.toString(),
                            Field8TabVal: response.data.Field8TabVal.toString(),
                            Field9TabVal: response.data.Field9TabVal.toString(),
                            Field10TabVal: response.data.Field10TabVal.toString(),
                            Field11TabVal: response.data.Field11TabVal.toString(),
                            Field12TabVal: response.data.Field12TabVal.toString(),
                            Field13TabVal: response.data.Field13TabVal.toString(),
                            Field14TabVal: response.data.Field14TabVal.toString(),
                            Field15TabVal: response.data.Field15TabVal.toString(),
                            Field16TabVal: response.data.Field16TabVal.toString(),
                            Field17TabVal: response.data.Field17TabVal.toString(),
                            Field18TabVal: response.data.Field18TabVal.toString(),
                            Field19TabVal: response.data.Field19TabVal.toString(),
                            Field20TabVal: response.data.Field20TabVal.toString(),
                            Master1TabVal: response.data.Master1TabVal.toString(),
                            Master2TabVal: response.data.Master2TabVal.toString(),
                            Master3TabVal: response.data.Master3TabVal.toString(),
                            Master4TabVal: response.data.Master4TabVal.toString(),
                            Master5TabVal: response.data.Master5TabVal.toString(),
                            DProductCodeTabVal: response.data.DProductCodeTabVal.toString(),
                            DProductNameTabVal: response.data.DProductNameTabVal.toString(),
                            DDescriptionTabVal: response.data.DDescriptionTabVal.toString(),
                            DBrandTabVal: response.data.DBrandTabVal.toString(),
                            DCountryTabVal: response.data.DCountryTabVal.toString(),
                            DYRRefTabVal: response.data.DYRRefTabVal.toString(),
                            DManufTabVal: response.data.DManufTabVal.toString(),
                            DStockTabVal: response.data.DStockTabVal.toString(),
                            DUnitTabVal: response.data.DUnitTabVal.toString(),
                            DVatTabVal: response.data.DVatTabVal.toString(),
                            DVatTypeTabVal: response.data.DVatTypeTabVal.toString(),
                            DQuantityTabVal: response.data.DQuantityTabVal.toString(),
                            DUnitPriceTabVal: response.data.DUnitPriceTabVal.toString(),
                            DCostTabVal: response.data.DCostTabVal.toString(),
                            DTCostTabVal: response.data.DTCostTabVal.toString(),
                            DQCostTabVal: response.data.DQCostTabVal.toString(),
                            DBonusTabVal: response.data.DBonusTabVal.toString(),
                            DGrossTabVal: response.data.DGrossTabVal.toString(),
                            DDiscountValueTabVal: response.data.DDiscountValueTabVal.toString(),
                            DDiscountTypeTabVal: response.data.DDiscountTypeTabVal.toString(),
                            DDiscountTabVal: response.data.DDiscountTabVal.toString(),
                            DOtherChargesTabVal: response.data.DOtherChargesTabVal.toString(),
                            DTaxableTabVal: response.data.DTaxableTabVal.toString(),
                            DTotalVATTabVal: response.data.DTotalVATTabVal.toString(),
                            DRoundOffVatTabVal: response.data.DRoundOffVatTabVal.toString(),
                            DExtraChargesTabVal: response.data.DExtraChargesTabVal.toString(),
                            DTotalTabVal: response.data.DTotalTabVal.toString(),
                            DWarehouseTabVal: response.data.DWarehouseTabVal.toString(),
                            DField1TabVal: response.data.DField1TabVal.toString(),
                            DField2TabVal: response.data.DField2TabVal.toString(),
                            DField3TabVal: response.data.DField3TabVal.toString(),
                            DField4TabVal: response.data.DField4TabVal.toString(),
                            DField5TabVal: response.data.DField5TabVal.toString(),
                            DField6TabVal: response.data.DField6TabVal.toString(),
                            DField7TabVal: response.data.DField7TabVal.toString(),
                            DField8TabVal: response.data.DField8TabVal.toString(),
                            DField9TabVal: response.data.DField9TabVal.toString(),
                            DField10TabVal: response.data.DField10TabVal.toString(),
                            DField11TabVal: response.data.DField11TabVal.toString(),
                            DField12TabVal: response.data.DField12TabVal.toString(),
                            DField13TabVal: response.data.DField13TabVal.toString(),
                            DField14TabVal: response.data.DField14TabVal.toString(),
                            DField15TabVal: response.data.DField15TabVal.toString(),
                            DField16TabVal: response.data.DField16TabVal.toString(),
                            DField17TabVal: response.data.DField17TabVal.toString(),
                            DField18TabVal: response.data.DField18TabVal.toString(),
                            DField19TabVal: response.data.DField19TabVal.toString(),
                            DField20TabVal: response.data.DField20TabVal.toString(),
                            DMaster6TabVal: response.data.DMaster6TabVal.toString(),
                            DMaster7TabVal: response.data.DMaster7TabVal.toString(),
                            DMaster8TabVal: response.data.DMaster8TabVal.toString(),
                            DFreightCharges: response.data.DFreightCharges.toString(),
                            DClearingCharges: response.data.DClearingCharges.toString(),
                            DDutyCharges: response.data.DDutyCharges.toString(),
                            DDeliveryCharges: response.data.DDeliveryCharges.toString(),
                            DPackingCharges: response.data.DPackingCharges.toString(),
                        }


                    } else {
                        $scope.Vdesign = {
                            DateTabVal: "-1",
                            CustomerTabVal: "-1",
                            CustomerMobTabVal: "-1",
                            CustomerAddressTabVal: "-1",
                            ExcelTabVal: "-1",
                            CRDRAccountTabVal: "-1",
                            CurrencyTabVal: "-1",
                            RemarksTabVal: "-1",
                            IntroLetterTabVal: "-1",
                            EndLetterTabVal: "-1",
                            ValidityTabVal: "-1",
                            ConcernPersonTabVal: "-1",
                            PlaceOfSupplyTabVal: "-1",
                            ShippingAddressTabVal: "-1",
                            SupplierBillNoTabVal: "-1",
                            SupplierQTNNoTabVal: "-1",
                            WeightTabVal: "-1",
                            NoOfPackagesTabVal: "-1",
                            GrossWeightTabVal: "-1",
                            NetWeightTabVal: "-1",
                            EnquiryNoTabVal: "-1",
                            OrderNoTabVal: "-1",
                            WarrentyPeriodTabVal: "-1",
                            DeliveryPeriodTabVal: "-1",
                            DeliveryBasisTabVal: "-1",
                            PaymentTermsTabVal: "-1",
                            DeliveryDateTabVal: "-1",
                            ReturnDateTabVal: "-1",
                            ReturnTimeTabVal: "-1",
                            SupplierBillDateTabVal: "-1",
                            SalesEmployeeTabVal: "-1",
                            CustomerPOTabVal: "-1",
                            SupplierPOTabVal: "-1",
                            Field1TabVal: "-1",
                            Field2TabVal: "-1",
                            Field3TabVal: "-1",
                            Field4TabVal: "-1",
                            Field5TabVal: "-1",
                            Field6TabVal: "-1",
                            Field7TabVal: "-1",
                            Field8TabVal: "-1",
                            Field9TabVal: "-1",
                            Field10TabVal: "-1",
                            Field11TabVal: "-1",
                            Field12TabVal: "-1",
                            Field13TabVal: "-1",
                            Field14TabVal: "-1",
                            Field15TabVal: "-1",
                            Field16TabVal: "-1",
                            Field17TabVal: "-1",
                            Field18TabVal: "-1",
                            Field19TabVal: "-1",
                            Field20TabVal: "-1",
                            Master1TabVal: "-1",
                            Master2TabVal: "-1",
                            Master3TabVal: "-1",
                            Master4TabVal: "-1",
                            Master5TabVal: "-1",
                            DProductCodeTabVal: "-1",
                            DProductNameTabVal: "-1",
                            DDescriptionTabVal: "-1",
                            DBrandTabVal: "-1",
                            DCountryTabVal: "-1",
                            DYRRefTabVal: "-1",
                            DManufTabVal: "-1",
                            DStockTabVal: "-1",
                            DUnitTabVal: "-1",
                            DVatTabVal: "-1",
                            DVatTypeTabVal: "-1",
                            DQuantityTabVal: "-1",
                            DUnitPriceTabVal: "-1",
                            DCostTabVal: "-1",
                            DTCostTabVal: "-1",
                            DQCostTabVal: "-1",
                            DBonusTabVal: "-1",
                            DGrossTabVal: "-1",
                            DDiscountValueTabVal: "-1",
                            DDiscountTypeTabVal: "-1",
                            DDiscountTabVal: "-1",
                            DOtherChargesTabVal: "-1",
                            DTaxableTabVal: "-1",
                            DTotalVATTabVal: "-1",
                            DRoundOffVatTabVal: "-1",
                            DExtraChargesTabVal: "-1",
                            DTotalTabVal: "-1",
                            DWarehouseTabVal: "-1",
                            DField1TabVal: "-1",
                            DField2TabVal: "-1",
                            DField3TabVal: "-1",
                            DField4TabVal: "-1",
                            DField5TabVal: "-1",
                            DField6TabVal: "-1",
                            DField7TabVal: "-1",
                            DField8TabVal: "-1",
                            DField9TabVal: "-1",
                            DField10TabVal: "-1",
                            DField11TabVal: "-1",
                            DField12TabVal: "-1",
                            DField13TabVal: "-1",
                            DField14TabVal: "-1",
                            DField15TabVal: "-1",
                            DField16TabVal: "-1",
                            DField17TabVal: "-1",
                            DField18TabVal: "-1",
                            DField19TabVal: "-1",
                            DField20TabVal: "-1",
                            DMaster6TabVal: "-1",
                            DMaster7TabVal: "-1",
                            DMaster8TabVal: "-1",
                            DFreightCharges: "-1",
                            DClearingCharges: "-1",
                            DDutyCharges: "-1",
                            DDeliveryCharges: "-1",
                            DPackingCharges: "-1",
                        }
                    }

                    $.LoadingOverlay("hide");

                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }



            $scope.saveCostSettings = function () {

                $scope.Vdesign.VoucherName = $scope.ViewValType;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.AddTabDesign($scope.Vdesign).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                        $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }



      }]);
